/**
 * @generated SignedSource<<f242e14b32c471ff2387925f998bd440>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type topBar_issueNavigator_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"src_issueTableHideDoneToggle_HideDoneItemsToggle_project" | "ui_issueTableGroupByDropdown_GroupByDropdown_project">;
  readonly " $fragmentType": "topBar_issueNavigator_project";
};
export type topBar_issueNavigator_project$key = {
  readonly " $data"?: topBar_issueNavigator_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"topBar_issueNavigator_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "topBar_issueNavigator_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle_project"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_issueTableGroupByDropdown_GroupByDropdown_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "cdd44eaaa7bb7354447f0a1176ab8012";

export default node;
